import React from 'react';
import { Tooltip, Intent } from '@blueprintjs/core';
import intl from 'react-intl-universal';
import classNames from 'classnames';
import './AILoadingIndicator.scss';

interface AILoadingIndicatorProps {
  isLoading: boolean;
  showLabel?: boolean;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const AILoadingIndicator: React.FC<AILoadingIndicatorProps> = ({
  isLoading,
  showLabel = false,
  size = 'medium',
  className,
}) => {
  if (!isLoading) {
    return null;
  }

  const sizeClasses = {
    small: 'ai-loading-indicator--small',
    medium: 'ai-loading-indicator--medium',
    large: 'ai-loading-indicator--large',
  };

  const content = (
    <div className={classNames('ai-loading-indicator', sizeClasses[size], className)}>
      <svg
        className="ai-loading-indicator__sparkle"
        viewBox="0 0 50 50"
        width="1em"
        height="1em"
        fill="currentColor"
      >
        {/* Main large sparkle - centered */}
        <path d="M25 5C25 5 28 12 31 16C34 20 41 23 41 23C41 23 34 26 31 30C28 34 25 41 25 41C25 41 22 34 19 30C16 26 9 23 9 23C9 23 16 20 19 16C22 12 25 5 25 5Z" />

        {/* Small sparkle top-right - far from main */}
        <path d="M42 8C42 8 43 10 44 11C45 12 47 13 47 13C47 13 45 14 44 15C43 16 42 18 42 18C42 18 41 16 40 15C39 14 37 13 37 13C37 13 39 12 40 11C41 10 42 8 42 8Z" />

        {/* Small sparkle bottom-left - far from main */}
        <path d="M8 35C8 35 9 37 10 38.5C11 40 13 41 13 41C13 41 11 42 10 43.5C9 45 8 47 8 47C8 47 7 45 6 43.5C5 42 3 41 3 41C3 41 5 40 6 38.5C7 37 8 35 8 35Z" />
      </svg>
      {showLabel && (
        <span className="ai-loading-indicator__label">
          {intl.get('ai_loading.suggesting')}
        </span>
      )}
    </div>
  );

  return (
    <Tooltip
      content={intl.get('ai_loading.ai_doing_it_for_you')}
      position="right"
      intent={Intent.PRIMARY}
      hoverOpenDelay={200}
      minimal={false}
      usePortal={false}
    >
      {content}
    </Tooltip>
  );
};

export default AILoadingIndicator;
